export default {
  firstName: 'First name',
  lastName: 'Last name',
  sendAgain: 'Send again',
  createAccount: 'Create new account ',
  email: 'Email (We recommend you use your business email address)',
  enterPassword: 'Enter password',
  rePassword: 'Re-enter password',
  tips: 'By clicking "Register" or "Continue with LinkedIn", I accept the Terms Of Service.',
  register: 'Register',
  success: 'Register successfully',
  exists: 'Already Registered, please login',
  //
  required: 'Please enter the verification code',
  backLogin: 'back',
  createAccount1: 'Create Account',
  email1: 'Email',
  recommendEmail: 'Recommend to use company emails',
  setPass: 'Password',
  showPasswordRules:
    'Password must be at least 8 characters long and contain at least a letter',
  confirmPass: 'Re-enter password',
  or: 'or',
  linkedinLogin: 'LinkedIn Login',
  inputEmail: 'Please enter your email',
  needCanUseEmail: 'Please provide a valid email address',
  setPassPop: 'Please input password',
  eightMinPassword: 'Password must be at least 8 character long',
  passwordRules: 'Please follow password rules',
  confirmPassPop: 'Please confirm your password',
  reInputPassword: 'Please confirm your password ',
  noMatchPassword: 'Passwords do not match',
  acceptTermsPop: 'Please accept terms and conditions',
  emailConsent: 'EMAIL CONSENT',
  emailConsentText:
    'To ensure you stay up-to-date on the latest developments in the mobile industry, we would like to send you information about events, products, services and initiatives, as well as industry news. Please subscribe by ticking this box; once subscribed, you can tailor what you receive from us at any time, or unsubscribe, should you wish.',
  ruleLastName: 'please input your last name',
  ruleFirstName: 'please input your first name',
}
